import _regeneratorRuntime from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createForOfIteratorHelper from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { isInArray, itemFromArray, loadFont } from "../../Utils/Utils";
export var validTypes = ["text", "character", "char"];
export var TextDrawer = /*#__PURE__*/function () {
  function TextDrawer() {
    _classCallCheck(this, TextDrawer);
  }
  _createClass(TextDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount() {
      return 12;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(container) {
        var options, shapeOptions, promises, _iterator, _step, character;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = container.actualOptions;
                if (!validTypes.find(function (t) {
                  return isInArray(t, options.particles.shape.type);
                })) {
                  _context.next = 14;
                  break;
                }
                shapeOptions = validTypes.map(function (t) {
                  return options.particles.shape.options[t];
                }).find(function (t) {
                  return !!t;
                });
                if (!(shapeOptions instanceof Array)) {
                  _context.next = 11;
                  break;
                }
                promises = [];
                _iterator = _createForOfIteratorHelper(shapeOptions);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    character = _step.value;
                    promises.push(loadFont(character));
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                _context.next = 9;
                return Promise.allSettled(promises);
              case 9:
                _context.next = 14;
                break;
              case 11:
                if (!(shapeOptions !== undefined)) {
                  _context.next = 14;
                  break;
                }
                _context.next = 14;
                return loadFont(shapeOptions);
              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function init(_x) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "draw",
    value: function draw(context, particle, radius, opacity) {
      var _a, _b, _c;
      var character = particle.shapeData;
      if (character === undefined) {
        return;
      }
      var textData = character.value;
      if (textData === undefined) {
        return;
      }
      var textParticle = particle;
      if (textParticle.text === undefined) {
        textParticle.text = textData instanceof Array ? itemFromArray(textData, particle.randomIndexData) : textData;
      }
      var text = textParticle.text;
      var style = (_a = character.style) !== null && _a !== void 0 ? _a : "";
      var weight = (_b = character.weight) !== null && _b !== void 0 ? _b : "400";
      var size = Math.round(radius) * 2;
      var font = (_c = character.font) !== null && _c !== void 0 ? _c : "Verdana";
      var fill = particle.fill;
      var offsetX = text.length * radius / 2;
      context.font = "".concat(style, " ").concat(weight, " ").concat(size, "px \"").concat(font, "\"");
      var pos = {
        x: -offsetX,
        y: radius / 2
      };
      context.globalAlpha = opacity;
      if (fill) {
        context.fillText(text, pos.x, pos.y);
      } else {
        context.strokeText(text, pos.x, pos.y);
      }
      context.globalAlpha = 1;
    }
  }]);
  return TextDrawer;
}();